import { NodeModel } from '@minoru/react-dnd-treeview';
import {
    InconsistenciesByEmployeeModel,
    InconsistenciesByPeopleModel,
    InconsistenciesModel,
} from '../../models/inconsistencies-validation/inconsistenciesValidation';
import { getDatesBetweenDates, getChildNodes } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    inconsistenciesValidation: InconsistenciesByPeopleModel;
    handlerOpenDetailsInconsistenciesModal: (
        startDate: string | number,
        endDate: string | number,
        employee: NodeModel[],
        inconsistencies: InconsistenciesByEmployeeModel[]
    ) => void;
};

export const controllerDetailsInconsistenciesModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    inconsistenciesValidation,
    handlerOpenDetailsInconsistenciesModal,
}: Props) => {
    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    let selectedEmployee = getChildNodes(treeEmployees).slice(row1, row2 + 1);

    let hasEmployeeInconsistencies =
        inconsistenciesValidation.inconsistenciesByEmployee.filter(
            (e) =>
                e.employeeId == selectedEmployee[0].id &&
                e.date.split('T')[0] == initDate &&
                e.date.split('T')[0] == lastDate
        );

    console.log(hasEmployeeInconsistencies);

    if (
        initDate === lastDate &&
        selectedEmployee.length == 1 &&
        hasEmployeeInconsistencies.length > 0
    ) {
        handlerOpenDetailsInconsistenciesModal(
            initDate,
            lastDate,
            selectedEmployee,
            hasEmployeeInconsistencies
        );
    }
};
